// UI Constants
export const UI_CONSTANTS = {
  // Colors
  COLORS: {
    PRIMARY: 'orange',
    SECONDARY: 'amber',
    ACCENT: 'purple',
    SUCCESS: 'green',
    WARNING: 'yellow',
    ERROR: 'red'
  },

  // Spacing
  SPACING: {
    XS: 'p-2',
    SM: 'p-4',
    MD: 'p-6',
    LG: 'p-8',
    XL: 'p-12'
  },

  // Border Radius
  RADIUS: {
    SM: 'rounded-lg',
    MD: 'rounded-xl',
    LG: 'rounded-2xl',
    FULL: 'rounded-full'
  },

  // Shadows
  SHADOWS: {
    SM: 'shadow-sm',
    MD: 'shadow-md',
    LG: 'shadow-lg',
    XL: 'shadow-xl'
  },

  // Typography
  TYPOGRAPHY: {
    HEADING_1: 'text-3xl md:text-4xl font-bold',
    HEADING_2: 'text-2xl font-bold',
    HEADING_3: 'text-lg font-semibold',
    BODY: 'text-base',
    CAPTION: 'text-sm',
    SMALL: 'text-xs'
  },

  // Transitions
  TRANSITIONS: {
    DEFAULT: 'transition-all duration-300',
    FAST: 'transition-all duration-200',
    SLOW: 'transition-all duration-500'
  }
};

// Responsive breakpoints
export const BREAKPOINTS = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
};

// Grid configurations
export const GRID_CONFIGS = {
  SERVICE_CATEGORIES: {
    base: 'grid-cols-2',
    sm: 'sm:grid-cols-3',
    md: 'md:grid-cols-4',
    lg: 'lg:grid-cols-6',
    xl: 'xl:grid-cols-6'
  },
  POPULAR_SERVICES: {
    base: 'grid-cols-1',
    sm: 'sm:grid-cols-2',
    md: 'md:grid-cols-3',
    lg: 'lg:grid-cols-4',
    xl: 'xl:grid-cols-4'
  },
  NEW_SERVICES: {
    base: 'grid-cols-2',
    sm: 'sm:grid-cols-2',
    md: 'md:grid-cols-4',
    lg: 'lg:grid-cols-4',
    xl: 'xl:grid-cols-4'
  },
  STATS: {
    base: 'grid-cols-3'
  }
};
